import { render, staticRenderFns } from "./MediaAccreditationEvents.vue?vue&type=template&id=60a4f6c0&scoped=true&"
import script from "./MediaAccreditationEvents.vue?vue&type=script&lang=js&"
export * from "./MediaAccreditationEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a4f6c0",
  null
  
)

export default component.exports